import { Layout, UI } from 'common';
import React, { Component } from 'react';

const { WrappedRadioButton } = UI;

class LabelStatusCellRenderer extends Component {
	constructor(props) {
		super(props);
		const { data } = props;
		this.state = {
			isAutoRefundOptOut: data.isAutoRefundOptOut,
			universalPostageID: data.universalPostageID,
		};
	}

	render() {
		const { isAutoRefundOptOut, universalPostageID } = this.state;
		const { onSelect } = this.props;

		const onClickRadioButton = e => {
			onSelect(e);
			this.setState({
				isAutoRefundOptOut: e.value === 'shipped',
			});
		};

		return (
			<div className="label-status">
				<WrappedRadioButton
					name={universalPostageID}
					inputId="refundeligibilityreport-labelstatuscheckbox-notshipped"
					checked={!isAutoRefundOptOut}
					onChange={onClickRadioButton}
					dataqa="refundeligibilityreport-labelstatuscheckbox-notshipped"
					value="not shipped"
				>
					Not Shipped
				</WrappedRadioButton>
				<WrappedRadioButton
					name={universalPostageID}
					inputId="refundeligibilityreport-labelstatuscheckbox-shipped"
					checked={isAutoRefundOptOut}
					onChange={onClickRadioButton}
					dataqa="refundeligibilityreport-labelstatuscheckbox-shipped"
					value="shipped"
				>
					Shipped
				</WrappedRadioButton>
			</div>
		);
	}
}

LabelStatusCellRenderer.contextType = Layout.LayoutContext;

export default LabelStatusCellRenderer;
